import NavBar, { NavItems, BottomNavItems, SelectedNavItem, NavItem, NavKey, enabledNavItems } from './v1';

export { NavBar, NavItems, BottomNavItems, SelectedNavItem, NavItem, NavKey, enabledNavItems };

export default NavBar;
